import { render, staticRenderFns } from "./PWAInstallPrompt.vue?vue&type=template&id=ffb3a9b0&scoped=true"
import script from "./PWAInstallPrompt.vue?vue&type=script&lang=js"
export * from "./PWAInstallPrompt.vue?vue&type=script&lang=js"
import style0 from "./PWAInstallPrompt.vue?vue&type=style&index=0&id=ffb3a9b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb3a9b0",
  null
  
)

export default component.exports